import logo from "../../images/GraphologiIcon.svg";
import * as React from "react";
import {useState} from "react";
import {getAuthorizationToken} from "./go-api";
import {Box} from "@material-ui/core";
import TextField from "../TextField";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import ErrorMessage from "../ErrorMessage";

let GOLoginInfo = {}

export function setGOLoginInfo(username, password) {
    GOLoginInfo = {username, password};
}

export function getGOLoginUsername() {
    return GOLoginInfo.username;
}

export function getGOLoginPassword() {
    return GOLoginInfo.password;
}

export default function Authenticate({configuration, onSuccess, onCancelButtonClick}) {
    const [loginError, setLoginError] = useState('');
    const [username, setUsername] = useState(getGOLoginUsername() || '');
    const [password, setPassword] = useState(getGOLoginPassword() || '');

    const handleSignIn = (event, values) => {
        event.preventDefault();

        getAuthorizationToken(configuration, username, password).then(r => {
            if(r.error) {
                setLoginError(r.error);
            } else {
                setLoginError(undefined);
                onSuccess(r);
                setGOLoginInfo(username, password);
            }
        })
    }

    const shouldLoginButtonBeDisabled = () => {
        if(!username || !password) {
            return true;
        }
        return false;
    }

    return <Box sx={{ display: 'flex', margin : "16px 0px" }}>
        <Box sx={{flexGrow  :'1'}}></Box>
        <Box sx={{maxWidth : '320px' }}>
            <div style={{textAlign: 'center'}}><img src={logo} alt="Graphologi Logo"  width="72" /></div>
            <Grid container spacing={3}>
            {loginError &&
                <Grid item xs={12}>
                    <ErrorMessage datatest={'errorMessage'} error={loginError}/>
                </Grid>
            }
                <Grid item xs={12}>
            <TextField
                label={'Username'}
                onChange={(event) => {
                    const {target: {name, value}} = event;
                    setUsername(value);
                }}
                value={username}
            />
                </Grid>
                <Grid item xs={12}>
            <TextField
                type="password"
                label={'Password'}
                onChange={(event) => {
                    const {target: {name, value}} = event;
                    setPassword(value);
                }}
                value={password}
            />
                </Grid>
            <Grid container item xs={12}>
                <Grid item xs={6}>
                    { onCancelButtonClick &&
                    <Button
                        datatest={'signupButton'}
                        onClick={onCancelButtonClick}
                        variant={'text'}
                        color={'secondary'}
                    >Cancel</Button>
                    }
                </Grid>
                <Grid style={{textAlign: 'right'}} item xs={6}>
                    <Button
                        datatest={'loginButton'}
                        disabled={shouldLoginButtonBeDisabled()}
                        onClick={handleSignIn}
                        variant={'contained'}
                        color={'secondary'}
                    >Login</Button>
                </Grid>
            </Grid>
            </Grid>

        </Box>
        <Box sx={{flexGrow  :'1'}}></Box>
    </Box>;

}